import cls from "./linkedfielddisplayrender.module.scss";
import React, {useEffect, useState} from "react";
import {extract, fieldDefaultConfig, getRFDOptions, renderTemplate, renderValue, wrapArray} from "../../utils";
import Table from "../../Table";
import {DataView} from "primereact/dataview";
import DisplayRendering from "../../DisplayRendering";
import _ from "lodash"
import parseCss from "style-to-js";
import {Paginator as PRPaginator} from "primereact/paginator";

/***
 * Linked Field Display Render component
 *
 * @author: Daniel Correa
 *
 */

type LinkedFieldDisplayRenderProps = {
    /** value to render */
    value: any,
    /** component instance name*/
    name: string,
    /** environment */
    env: string,
    /** parent details */
    details?: any,
    /** parent extraConfig */
    extraConfig?: any;


}


export const LinkedFieldDisplayRender = (props: LinkedFieldDisplayRenderProps) => {
    const {value, name, details, extraConfig} = props;
    const linkedValues = wrapArray(value)
    const {
        format_mode = '',
        select_layout = '', combine_fields = false,
        mobile_columns = '',
        number_of_columns = '', row_height = '', paginate = false, emptyMessage = ''
    } = extraConfig;
    const isCombined = combine_fields && select_layout === 'list' && format_mode === 'fields';
    const isPaginate = !isCombined && paginate
    const isTable = !isCombined && select_layout === 'list' && format_mode === 'fields';
    const displayFields = _.get(extraConfig, 'display_fields.fields', [])
    const columns = displayFields.map(field => ({
        ...field,
        label: field.column_header || field.name,

    }));
    const env = 'linked_display'
    const [page, setPage] = useState(0);
    let numCols = 1
    if( select_layout === 'grid'){
        numCols = number_of_columns
    }
    const determineCols = ( cols, mobileCols = null) => {
        const lg = Math.floor(12 / cols)
        const md = Math.max( 4, lg )
        const sm = mobileCols ? Math.floor( 12 / Number(mobileCols)) :  Math.max(6,md)
        const out = `lg:col-${lg} md:col-${md} col-${sm}`
        return out
    }
    let gridCols = determineCols(numCols, mobile_columns)

    const itemsToRender = (_page) => {
        const start = _page === 0 ? 0 : _page * (isTable ? extraConfig.rows_per_page : numCols * extraConfig.rows_per_page);
        const len = isPaginate ? (isTable ? extraConfig.rows_per_page : numCols * extraConfig.rows_per_page) -1 : linkedValues.length;
        const end = start + len;
        const pageDataValues = linkedValues.reduce((pageData, element, index) => {
            if (index >= start && index <= end) {
                pageData.push(element);
            }
            return pageData;
        }, [])
        console.log('itemsToRender', _page, start, len, end, isTable, extraConfig.rows_per_page, numCols, pageDataValues, linkedValues)
        return pageDataValues
    }
    const [dataValues, setDataValues] = useState(itemsToRender(0))

    useEffect( () => {
        setPage(0)
        setDataValues(itemsToRender(0))
    }, [value])

    const renderData = (_item) => {
        let outputs = [];
        let items = wrapArray(_item)
        columns.forEach(column => {
            const defs = fieldDefaultConfig(env, column.type, column.options, column)
            const {render_as, display_as} = getRFDOptions(defs, column);
            console.log('Rendering Linked Field Value',env, _item, column, defs)
            outputs.push(<div>
                <div className={cls.recordName}
                     style={parseCss(_.get(extraConfig, "controls.styles.label"))}>{column.label}</div>
                <div className={cls.recordDescription} style={parseCss(_.get(extraConfig, "controls.styles.values"))}>
                    <DisplayRendering value={items.map( item => item[column.name])} name={column.name} {...{
                        env,
                        extraConfig: {
                            divider: isCombined ? ', ' : '',
                            inline: isCombined,
                            render_as: render_as,
                            display_as: display_as,
                            ...(display_as === 'carousel' ? {orientation:'vertical'} : {}),
                            ...column,

                            // ...extract({template:undefined}, extraConfig)
                        }
                    }} />

                </div>
            </div>)
        })
        return outputs;

    }

    /** item template used to render RichText layout. In case of grid the number of columns per row will follow the user setup otherwise just one column will be displayed.*/
    const itemTemplateRichText = (item) => {
        console.log('itemTemplateRichText', item, gridCols, extraConfig)
        return <div
            className={select_layout === 'grid' ? gridCols : 'col-12'}>
            <div className={cls.recordGridItem} style={row_height ? {height: row_height} : {height: '100%'}}>
                {renderTemplate(extraConfig?.fields_format?.content, item, {render_as: extraConfig.fields_format?.render_as || 'markdown'}).value}
            </div>
        </div>
    }
    /** item template used to render table layout with more than one column set.*/
    const itemTemplateTable = (item) => {
        return <div className={gridCols}>
            <div className={cls.recordGridItem} style={row_height ? {height: row_height} : {height: '100%'}}>
                <div className={cls.recordGridItemTop}>
                    <table className={cls.stackTable}>
                        <tbody>
                        {renderData(item)}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>;
    }

    /** combination of list + table displays a regular table */
    const renderTable = () => {
        const totalRecords = linkedValues.length;
        const paginator = isPaginate && totalRecords > 0  && totalRecords > Number(extraConfig.rows_per_page);
        const tableExtraConfig = paginator ?  {...extraConfig, table:{ paginator : true,  rows: extraConfig.rows_per_page }} : extraConfig;
        return <Table env={env} name={name} form_id={null} display_as={'table'} mode={'table'} value={value}
                      getRecord={null} createForm={null} details={details} extraConfig={tableExtraConfig}
                      recordSearch={null} onSaveEdit={null}/>
    }
    /** combination of grid + table or richtext  displays a data view */
    const renderDataView = (itemTemplateRender, mode) => {
        const totalRecords = valuesToRow().length - 1;
        console.log('renderDataView', totalRecords, dataValues, mode)
        return <> <DataView value={dataValues} layout={mode}
                            itemTemplate={itemTemplateRender}/>
            {isPaginate && totalRecords > 0  && totalRecords > Number(extraConfig.rows_per_page) ?
                <PRPaginator first={page} rows={extraConfig.rows_per_page} totalRecords={totalRecords}
                             onPageChange={onChangePage}/> : ''}
        </>
    }

    const renderMergedDataView = (itemTemplateRender) => {
        //pass all as a single item
        return <> <DataView value={[dataValues]} layout={'list'}
                            itemTemplate={itemTemplateRender}/>
            </>
    }

    /** rebuild data to render and set current page*/
    const onChangePage = (event) => {
        setPage(event.first)
        setDataValues(itemsToRender(event.first))
    }


    /** create a matrix to store values per row regarding number_of_columns */
    const valuesToRow = () => {
        let total = 0;
        return linkedValues.reduce((groupedValues, data) => {
            if (!groupedValues[Math.floor(total / numCols) + 1]) groupedValues[Math.floor(total / numCols) + 1] = []
            groupedValues[Math.floor(total / numCols) + 1].push(data);
            total++;
            return groupedValues;
        }, []);
    }
    console.log('LinkedFieldDisplayRender', {isTable, select_layout, format_mode, value, mobile_columns, linkedValues, extraConfig,gridCols, isCombined, isPaginate, displayFields})
    if(!linkedValues.length){
        return renderValue(emptyMessage || '')
    }
    if(isTable)return renderTable()
    else if(['grid','navigator'].includes(select_layout) && format_mode === 'fields')return renderDataView(itemTemplateTable, select_layout)
    else if(format_mode === 'richtext') return renderDataView(itemTemplateRichText, select_layout)
    else if(isCombined) return renderMergedDataView(itemTemplateTable)
    return <></>
    // return (
    //     <> { isTable ? renderTable() :
    //         select_layout === 'grid' && format_mode === 'fields' ? renderDataView(itemTemplateTable, 'grid') : format_mode === 'richtext' ? renderDataView(itemTemplateRichText, select_layout) :
    //             (isCombined ? renderMergedDataView(itemTemplateTable) : '')}
    //     </>
    // )

}
